import React from "react";

interface PencilIconProps {
  width?: number;
  height?: number;
  color?: string;
  onClick?: () => void;
  className?: string;
}

export const PencilIcon: React.FC<PencilIconProps> = ({
  width = 20,
  height = 20,
  color = "#0056D6",
  onClick,
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      onClick={onClick}
      className={className}
      role="button"
      aria-label="Edit"
    >
      <path
        d="M17.5026 17.5009H10.836M2.08594 17.9176L6.71033 16.139C7.00611 16.0252 7.154 15.9683 7.29237 15.894C7.41527 15.8281 7.53244 15.7519 7.64264 15.6664C7.7667 15.5701 7.87875 15.4581 8.10284 15.234L17.5026 5.83424C18.4231 4.91376 18.4231 3.42138 17.5026 2.5009C16.5822 1.58043 15.0898 1.58043 14.1693 2.5009L4.76951 11.9007C4.54542 12.1248 4.43337 12.2368 4.3371 12.3609C4.25158 12.4711 4.17544 12.5882 4.10947 12.7111C4.03519 12.8495 3.97831 12.9974 3.86455 13.2932L2.08594 17.9176ZM2.08594 17.9176L3.80104 13.4584C3.92377 13.1393 3.98513 12.9797 4.09039 12.9066C4.18237 12.8428 4.29619 12.8186 4.40618 12.8396C4.53205 12.8637 4.65292 12.9845 4.89467 13.2263L6.77725 15.1089C7.019 15.3506 7.13987 15.4715 7.16391 15.5973C7.18491 15.7073 7.16076 15.8212 7.09689 15.9131C7.02381 16.0184 6.86426 16.0798 6.54516 16.2025L2.08594 17.9176Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
